import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { SavedAccount, SavedAccountsStore } from './savedAccounts.types';

function accountKey(email: string, slug: string): string {
  return `${email.trim().toLowerCase()}::${slug.trim().toLowerCase()}`;
}
export const useSavedAccountsStore = create<SavedAccountsStore>()(
  devtools(
    persist(
      (set, get) => ({
        accounts: [],

        upsertAccount: (account) => {
          const entry: SavedAccount = {
            email: account.email.trim(),
            slug: account.slug.trim(),
            orgName: account.orgName.trim(),
          };
          const accounts = get().accounts;
          const key = accountKey(entry.email, entry.slug);
          const index = accounts.findIndex((a) => accountKey(a.email, a.slug) === key);

          if (index >= 0) {
            const existing = accounts[index];
            if (
              existing.email === entry.email &&
              existing.slug === entry.slug &&
              existing.orgName === entry.orgName
            ) {
              return;
            }
            set({
              accounts: accounts.map((a, i) => (i === index ? { ...a, ...entry } : a)),
            });
            return;
          }

          set({ accounts: [...accounts, entry] });
        },
        removeAccount: (slug, email) => {
          const key = accountKey(email, slug);
          set({
            accounts: get().accounts.filter((a) => accountKey(a.email, a.slug) !== key),
          });
        },
      }),
      {
        name: 'saved-accounts',
        partialize: (state) => ({ accounts: state.accounts }),
      },
    ),
    { name: 'SavedAccounts' },
  ),
);
